import Button from '../../../components/Buttons/Button';
import { useWizard } from '../../../components/Wizard';
import cn from '../../../lib/classNames';
import Layout from '../../Layout/LayoutStarted';

import styles from './Step0.module.scss';

type Step0Type = {};

export default function Step0(props: Step0Type) {
	const { nextStep } = useWizard();

	return (
		<Layout displayRightInfo={false}>
			<div className={styles.container}>
				<div className={styles.form}>
					<div className={cn(styles['form-container'], styles['form-auth-container'])}>
						<div className={styles['form-inner']}>
							<div className={styles['field-wrap']}>
								<h2 className={styles.title}>Congratulations! Your Business Plan is Ready</h2>

								<p className={styles['sub-title']}>
									You’ve successfully set up Safe-Xplore Business Edition. Now your team can
									securely manage reports, analyze data, and make informed decisions.
								</p>

								<p className={styles['list-title']}>What’s next?</p>

								<ul className={styles.list}>
									<li>Homebase risks dashboard</li>
									<li>Unlimited free reports</li>
									<li>Report history tracking</li>
								</ul>
							</div>

							<div className={cn(styles['form-inner'], styles['field-wrap-btn'])}>
								<Button
									className={cn(
										styles['button'],
										styles['variant-filled'],
										styles['color-secondary'],
									)}
									variant="filled"
									color="primary"
									onClick={() => nextStep()}
								>
									Continue Setup
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Layout>
	);
}
